import { render, staticRenderFns } from "./CaHistoryPop.vue?vue&type=template&id=48014589"
import script from "./CaHistoryPop.vue?vue&type=script&lang=js"
export * from "./CaHistoryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48014589')) {
      api.createRecord('48014589', component.options)
    } else {
      api.reload('48014589', component.options)
    }
    module.hot.accept("./CaHistoryPop.vue?vue&type=template&id=48014589", function () {
      api.rerender('48014589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CaHistoryPop.vue"
export default component.exports